import { translate } from '@teamleader/i18n';
import React, { useCallback, useContext, useState } from 'react';

import InvoiceList from './InvoiceList';
import { BoxProps } from '../../../../Components/UI/Box';
import { canOpenNavigationForInvoice } from '../../../../Utils/canOpenNavigation';
import useGlobalContext, { InvoiceContext } from '../../Context';
import MobileNavigation from '../MobileNavigation';

const InvoicesMobileNavigation: React.FC<BoxProps> = (props) => {
  const { openInvoices, paidInvoices, creditedInvoices, invoice, department, client } = useContext(InvoiceContext);
  const { handleCloseMenu } = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);
  const openMenu = useCallback(() => setIsOpen(true), []);
  const closeMenu = useCallback(() => setIsOpen(false), []);

  const [isOpenInvoicesCollapsed, setIsOpenInvoicesCollapsed] = useState(false);
  const [isPaidInvoicesCollapsed, setIsPaidInvoicesCollapsed] = useState(
    !paidInvoices?.data?.find((paidInvoice) => paidInvoice.id === invoice?.id),
  );
  const [isCreditedInvoicesCollapsed, setIsCreditedInvoicesCollapsed] = useState(
    !creditedInvoices?.data?.find((creditedInvoice) => creditedInvoice.id === invoice?.id),
  );

  const onInvoiceClick = useCallback(() => {
    handleCloseMenu!();
    closeMenu();
  }, [closeMenu, handleCloseMenu]);

  const canOpenMenu = canOpenNavigationForInvoice(openInvoices?.data, paidInvoices?.data, creditedInvoices?.data);

  return (
    <MobileNavigation
      onOpen={canOpenMenu ? openMenu : undefined}
      onClose={closeMenu}
      isOpen={isOpen}
      department={department}
      client={client}
      {...props}
    >
      {canOpenMenu && (
        <>
          <InvoiceList
            title={translate('openInvoices')}
            invoices={openInvoices}
            isCollapsed={isOpenInvoicesCollapsed}
            handleCollapse={setIsOpenInvoicesCollapsed}
            onInvoiceClick={onInvoiceClick}
          />
          <InvoiceList
            title={translate('paidInvoices')}
            invoices={paidInvoices}
            isCollapsed={isPaidInvoicesCollapsed}
            handleCollapse={setIsPaidInvoicesCollapsed}
            onInvoiceClick={onInvoiceClick}
          />
          <InvoiceList
            title={translate('creditedInvoices')}
            invoices={creditedInvoices}
            isCollapsed={isCreditedInvoicesCollapsed}
            handleCollapse={setIsCreditedInvoicesCollapsed}
            onInvoiceClick={onInvoiceClick}
          />
        </>
      )}
    </MobileNavigation>
  );
};

export default InvoicesMobileNavigation;
